import { render, staticRenderFns } from "./WzcOption.vue?vue&type=template&id=0aa98290&scoped=true"
import script from "./WzcOption.vue?vue&type=script&lang=js"
export * from "./WzcOption.vue?vue&type=script&lang=js"
import style0 from "./WzcOption.vue?vue&type=style&index=0&id=0aa98290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa98290",
  null
  
)

export default component.exports